import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds } from 'src/constants/personalizationIds'

export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={videos.uefa_euros.videoUrl}
    title="Watch the UEFA Euro 2024"
    subtitle="Fubo is the only way to watch every match"
    networkSet={'soccer'}
    //REMOVED: univision_removed
    // customNetworks={['fsn', 'fox', 'fs1', 'espn', 'bein', 'tudn', 'abc']}
    //REPLACED: univision_removed
    customNetworks={['fsn', 'fox', 'fs1', 'espn', 'bein', 'abc']}
    sportId={sportIds.Soccer}
  />
)
